import React from 'react';
import { Link } from 'react-router-dom';
import { 
  COMPANY_INFO, 
  SERVICES, 
  CASE_STUDIES, 
  CLIENTS, 
  PROCESS, 
  STATS 
} from '../constants';

function Home() {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <h1>{COMPANY_INFO.tagline}</h1>
        <p>{COMPANY_INFO.shortDescription}</p>
        <div className="hero-buttons">
          <Link to="/contact" className="btn btn-large">Get Started</Link>
          <Link to="/work" className="btn btn-secondary btn-large">See Our Work</Link>
        </div>
      </section>

      {/* Clients Section */}
      <section className="clients-section">
        <div className="container" style={{ padding: '2rem' }}>
          <p style={{ 
            color: 'var(--text-secondary)', 
            textAlign: 'center', 
            marginBottom: '2.5rem', 
            fontSize: '0.95rem', 
            textTransform: 'uppercase', 
            letterSpacing: '1px', 
            fontWeight: 600 
          }}>
            Trusted Partners Across Industries
          </p>
          <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
            {CLIENTS.map(client => (
              <div key={client.name} className="card" style={{ marginBottom: '1.5rem', padding: '2rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
                  <span style={{ fontSize: '3rem' }}>{client.logo}</span>
                  <div>
                    <h4 style={{ marginBottom: '0.5rem', color: 'var(--text-primary)' }}>{client.name}</h4>
                    <p style={{ margin: 0, color: 'var(--text-secondary)' }}>{client.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section>
        <div className="container">
          <div className="section-header">
            <h2>What We Do</h2>
            <p>We help businesses leverage technology to grow faster, work smarter, and stay secure</p>
          </div>
          <div className="grid grid-2">
            {SERVICES.map(service => (
              <div key={service.id} className="card">
                <span className="card-icon">{service.icon}</span>
                <h3>{service.title}</h3>
                <p>{service.shortDesc}</p>
                <Link 
                  to="/services" 
                  style={{ 
                    color: 'var(--primary-color)', 
                    fontWeight: 600, 
                    marginTop: '1rem', 
                    display: 'inline-block' 
                  }}
                >
                  Learn more →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Case Studies Section */}
      <section style={{ backgroundColor: 'var(--bg-light)' }}>
        <div className="container">
          <div className="section-header">
            <h2>Recent Projects</h2>
            <p>Real results for real businesses</p>
          </div>
          <div className="grid grid-3">
            {CASE_STUDIES.map(study => (
              <div key={study.id} className="case-study">
                <div className="case-study-header">
                  <span className="case-study-logo">{study.logo}</span>
                  <div className="case-study-info">
                    <h3>{study.client}</h3>
                    <p className="case-study-industry">{study.industry}</p>
                  </div>
                </div>
                <div className="case-study-details">
                  <div className="case-detail">
                    <strong>Challenge</strong>
                    <p style={{ margin: 0 }}>{study.challenge}</p>
                  </div>
                  <div className="case-detail case-result">
                    <strong>Result</strong>
                    <p style={{ margin: 0, color: 'var(--text-primary)' }}>{study.result}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Link to="/work" className="btn">View All Projects</Link>
          </div>
        </div>
      </section>

      {/* How We Work */}
      <section>
        <div className="container">
          <div className="section-header">
            <h2>How We Work</h2>
            <p>A simple, transparent process from start to finish</p>
          </div>
          <div className="process-grid">
            {PROCESS.map(step => (
              <div key={step.step} className="process-step">
                <div className="process-number">{step.step}</div>
                <h4>{step.title}</h4>
                <p>{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <div className="stats-grid">
          {STATS.map((stat, index) => (
            <div key={index} className="stat-item">
              <h3>{stat.number}</h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ background: 'var(--primary-color)', color: 'white', textAlign: 'center' }}>
        <div className="container">
          <h2 style={{ color: 'white' }}>Ready to Transform Your Business?</h2>
          <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '1.2rem', marginBottom: '2rem' }}>
            Let's talk about how we can help you grow. Book a free 30-minute consultation.
          </p>
          <Link to="/contact" className="btn" style={{ backgroundColor: 'white', color: 'var(--primary-color)' }}>
            Schedule a Call
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Home;